import script from "./loginArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./loginArea.vue?vue&type=script&lang=ts&setup=true"

import "./loginArea.vue?vue&type=style&index=0&id=bf061a0e&lang=scss&scoped=true"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf061a0e"]])

export default __exports__